import React, { useState, useEffect } from "react";
import clsx from 'clsx';
import { makeStyles } from "@material-ui/core/styles";
import MyDatePicker from './DatePicker';
import { Paper, IconButton, Button, ClickAwayListener, Box } from '@mui/material';
import { ChevronDown } from 'lucide-react';
import './DateSelectionStyle.css'

function DateSelectionFuture(props) {
  const classes = useStyles();
  var today = new Date();
  const [open, setOpen] = useState(false);
  const [custom, setCustom] = useState(true);
  const [weekSelected, setWeekSelected] = useState(false);
  const [monthSelected, setMonthSelected] = useState(true);
  const [yearSelected, setYearSelected] = useState(false);
  const [fromDate] = useState(props.FromDate);
  const [toDate] = useState(props.ToDate);

  const handleClickAway = () => {
    setOpen(false);
  };
  useEffect(() => {
    let diff = getNumberOfDays(props.FromDate, props.ToDate);
    if (sameDay(props.FromDate, new Date())) {
      if (diff === 7) {
        setWeekSelected(true);
        setMonthSelected(false);
        setYearSelected(false);
        setCustom(false);
      } else if (diff === 30) {
        setWeekSelected(false);
        setMonthSelected(true);
        setYearSelected(false);
        setCustom(false);
      } else if (diff === 365) {
        setWeekSelected(false);
        setMonthSelected(false);
        setYearSelected(true);
        setCustom(false);
      } else {
        setWeekSelected(false);
        setMonthSelected(false);
        setYearSelected(false);
        setCustom(true);
      }
    } else {
      setWeekSelected(false);
      setMonthSelected(false);
      setYearSelected(false);
      setCustom(true);

    }

  }, [fromDate, toDate]); // eslint-disable-line react-hooks/exhaustive-deps


  function sameDay(d1, d2) {
    return d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();
  }

  function getNumberOfDays(start, end) {
    const date1 = new Date(start);
    const date2 = new Date(end);

    // One day in milliseconds
    const oneDay = 1000 * 60 * 60 * 24;

    // Calculating the time difference between two dates
    const diffInTime = date2.getTime() - date1.getTime();

    // Calculating the no. of days between two dates
    const diffInDays = Math.round(diffInTime / oneDay);

    return diffInDays;
  }



  const setTheFromDate = (event) => {
    props.setDates(new Date(event), new Date(props.ToDate));
    props.setTheFromDate(event)
  }

  const setTheToDate = (event) => {
    props.setDates(new Date(props.FromDate), new Date(event));
    props.setTheToDate(event)
  }

  const handleOpen = () => {
    setOpen(!open);
  }

  const handleSeven = () => {
    let relevantDays = new Date(today);
    relevantDays.setDate(today.getDate() + 7);
    props.setDates(today, relevantDays);
    setWeekSelected(true);
    setYearSelected(false);
    setMonthSelected(false);
    setCustom(false);
  }

  const handleThirty = () => {
    let relevantDays = new Date(today);
    relevantDays.setDate(today.getDate() + 30);
    props.setDates(today, relevantDays);
    setMonthSelected(true);
    setYearSelected(false);
    setWeekSelected(false);
    setCustom(false);
  }

  const handleYear = () => {
    let relevantDays = new Date(today);
    relevantDays.setDate(today.getDate() + 365);
    props.setDates(today, relevantDays);
    setYearSelected(true);
    setMonthSelected(false);
    setWeekSelected(false);
    setCustom(false);
  }

  const handleCustom = () => {
    setCustom(!custom);
    setMonthSelected(false);
    setWeekSelected(false);
    setYearSelected(false);
  }

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div style={{ display: "inline-block" }}>
        <IconButton style={{ borderRadius: "5px" }} onClick={handleOpen}>{props.FromDate.toDateString() + " - " + props.ToDate.toDateString()}<ChevronDown /></IconButton>
        {open ?
          <div className={classes.card}>
            <div className={classes.buttonContainer}>
              <button className={clsx(classes.toggleButton, { [classes.selected]: weekSelected })} onClick={handleSeven}>Next week</button>
              <button className={clsx(classes.toggleButton, { [classes.selected]: monthSelected })} onClick={handleThirty}>Next 30 days</button>
              <button className={clsx(classes.toggleButton, { [classes.selected]: yearSelected })} onClick={handleYear}>Next year</button>
              <button className={clsx(classes.toggleButton, { [classes.selected]: custom })} onClick={handleCustom}>Date range</button>
            </div>
            <div className={classes.inputContainer}>
              <div className={classes.input}>
                <label className={classes.label}>From:</label>
                <MyDatePicker style={{ marginRight: "1rem" }} disabled={!custom} value={props.FromDate} toDate={props.ToDate} action={setTheFromDate} />
              </div>
              <div className={classes.input}>
                <label className={classes.label}>To:</label>
                <MyDatePicker value={props.ToDate} disabled={!custom} fromDate={props.FromDate} action={setTheToDate} />
              </div>
            </div>
          </div>
          : <React.Fragment></React.Fragment>}
      </div>
    </ClickAwayListener >
  );
}
export default DateSelectionFuture;

const useStyles = makeStyles((theme) => ({
  card: {
    position: "absolute",
    zIndex: "999",

    backgroundColor: "white",

    border: "1px solid #EDEDED",
    borderRadius: "8px",

    boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",

    marginTop: "6px",
    padding: "16px",

    [theme.breakpoints.down('xs')]: {
      left: "0px",
    },
  },

  buttonIcon: {
    width: "16px",
    height: "16px",
    display: "block",

    strokeWidth: "1.4px",
    color: "inherit",
  },

  dateRangeButton: {
    height: "28px",
    width: "240px",

    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    borderRadius: "4px",
    border: "1px solid #DCDCDC",

    backgroundColor: "white",

    fontSize: "14px",
    fontFamily: "Lato, sans-serif",
    color: "#0C0E29",

    "&:hover": {
      cursor: "pointer",
    }
  },

  buttonContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap",

    marginBottom: "16px",
  },

  toggleButton: {
    height: "40px",
    padding: "0 12px",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    position: "relative",

    border: "none",
    borderRadius: "4px",

    fontSize: "16px",
    color: "#a77d4f",
    backgroundColor: "transparent",
    border: "1px solid #a77d4f",

    transition: "all 0.2s ease-in-out",

    userSelect: "none",

    "&:hover": {
      backgroundColor: "#a77d4f",
      color: "white",
      cursor: "pointer",
    },
  },

  selected: {
    backgroundColor: "#a77d4f", // Style for the "selected" state
    color: "white",
    border: "1px solid #a77d4f", // Add a border for visual indication
  },

  clearDateRangeButton: {
    width: "24px",
    height: "24px",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    borderRadius: "2px",
    border: "none",

    backgroundColor: "transparent",
    color: "#0C0E29",

    padding: "0",

    "&:hover": {
      cursor: "pointer",
      color: "#D84949",
      backgroundColor: "#EDEDED",
    }
  },

  inputContainer: {
    display: 'flex',
    gap: '8px',
    flexDirection: 'row',
    justifyContent: 'space-evenly',

    [theme.breakpoints.down('sm')]: {
      flexDirection: "column",
    },
  },

  input: {
    display: 'flex',
    flexDirection: 'column',
    width: "50%",

    [theme.breakpoints.down('sm')]: {
      width: "100%",
    },
  },

  label: {
    fontSize: "16px",
    color: "rgb(105, 105, 105)",
    marginBottom: "4px",
  },

}));